import classNames from "classnames";
import { FC } from "react";
import InfiniteScroll from "react-infinite-scroller";
import AdsIds from "../../../../data/ads";
import { getLeagueMenu } from "../../../../data/leagues";
import { API } from "../../../../services/api/types";
import { getDynamicMobileTagId } from "../../../../utils/ads";
import * as TransferWindow from "../../../../utils/TransferWindow";
import Advertisement from "../../../Advertisement";
import ArticleItem from "../../../ArticleItem";
import ArticlePush from "../../../ArticleItem/ArticlePush";
import BreakingTeaser from "../../../BreakingTeaser";
import { BreakingTeaser as BreakingTeaserType } from "../../../BreakingTeaser/types";
import Container from "../../../Container";
import OnScreen from "../../../OnScreen";
import SectionHeader from "../../../SectionHeader";
import SectionMenuButton from "../../../SectionMenu/SectionMenuButton";

type MainFeedMobileProps = {
  news: API.Article[];
  featuredNews: API.Article[];
  category: FixMeLater;
  breakingTeasers: BreakingTeaserType[];
  transferWindow?: API.TransferWindow;
  onReachEnd: () => void;
  onClickCategory: (category: FixMeLater, index: number) => void;
  onArticleAppear: (article: API.Article, position: "above" | "below") => void;
  onArticleDisappear: (
    article: API.Article,
    position: "above" | "below",
  ) => void;
};

const MainFeedMobile: FC<MainFeedMobileProps> = (props) => {
  const renderPrimaryArticle = (article: API.Article, index: number) => {
    const isShowingAd = index % 4 === 0 && index > 0;
    const type = index % 4 === 0 ? "large" : "small";

    return (
      <div key={article.id} className={classNames(["py-5", "border-b"])}>
        {isShowingAd && (
          <div className={classNames("mb-5")}>
            <Advertisement
              id={AdsIds.dynamic_mobile}
              codeReplaceAll={() => ({ tagId: getDynamicMobileTagId() })}
            />
          </div>
        )}
        <OnScreen
          onAppear={(position) => props.onArticleAppear(article, position)}
          onDisappear={(position) =>
            props.onArticleDisappear(article, position)
          }
        >
          <ArticleItem type={type} article={article} />
        </OnScreen>
      </div>
    );
  };

  const renderSecondaryArticle = (article: API.Article, index: number) => {
    return (
      <div key={article.id} className={classNames(["py-5", "border-b"])}>
        <ArticleItem hideImage type={"small"} article={article} />
      </div>
    );
  };

  return (
    <InfiniteScroll hasMore={true} pageStart={0} loadMore={props.onReachEnd}>
      {props.breakingTeasers.map((breakingTeaser, index) => {
        const isLast = index === props.breakingTeasers.length - 1;

        return (
          <div
            key={breakingTeaser.link}
            className={classNames({ "border-b": !isLast }, "py-2")}
          >
            <BreakingTeaser teaser={breakingTeaser} />
          </div>
        );
      })}
      <div className={classNames("mb-3")} />
      <Container horizontalMargin opposite>
        <SectionHeader
          labelTag="h1"
          label="Transfernyheter"
          menu={
            <SectionMenuButton
              activeItem={props.category.index}
              items={getLeagueMenu(true).map((league, index) => {
                return {
                  label: league.title,
                  onClick: () => props.onClickCategory(league, index),
                };
              })}
            />
          }
        />
      </Container>
      {props.news.slice(0, 4).map(renderPrimaryArticle)}
      <div className={classNames("my-5")}>
        <Advertisement
          id={AdsIds.dynamic_mobile}
          codeReplaceAll={() => ({ tagId: getDynamicMobileTagId() })}
        />
      </div>
      <Container horizontalMargin opposite>
        <SectionHeader label="Toppnyheter" />
      </Container>
      {props.featuredNews.slice(0, 5).map(renderSecondaryArticle)}
      <div className={classNames("mt-5")}>
        <Advertisement id={AdsIds.mobile_native} />
      </div>
      {props.news.slice(4, 8).map(renderPrimaryArticle)}
      <div className={classNames("my-5")}>
        <Advertisement id={AdsIds.mobile_vi} />
      </div>
      <ArticlePush
        href="/nyheter/nar-oppnar-och-stanger-transferfonstret/1468"
        text="När öppnar och stänger transferfönstret? Se alla datum för 93 länder."
        bubbleText={TransferWindow.getText(
          new Date(),
          new Date(props?.transferWindow?.open || 0),
          new Date(props?.transferWindow?.close || 0),
          TransferWindow.SWEDISH
        )}
        imageSrc={`${process.env.NEXT_PUBLIC_ASSET_SERVER_URL}/uploads/images/news/1580518483/528x300.jpg`}
        imageAlt="Transferfönstret"
      />
      <div className={classNames("mb-5")} />
      {props.news.slice(8).map(renderPrimaryArticle)}
    </InfiniteScroll>
  );
};

export default MainFeedMobile;
